<ion-content [fullscreen]="true">
  <div (click)="modalCtrl.dismiss()"
    style="display: flex; align-items: center; padding: 16px; gap: 10px; border-bottom: 1px solid #E4E0EB;">
    <ion-icon style="font-size: 25px; color: #1E1725; cursor: pointer" name="chevron-back-outline"></ion-icon>
    <div style="width: calc(100% - 70px); color: #1E1725; padding-top: 2px;" class="body-md-semibold">
      Forwarding
    </div>
  </div>

  <app-loading *ngIf="isLoading === true"></app-loading>


  <div *ngIf="isLoading === false" style="padding: 16px;">
    <app-input-prefix-field [disabled]="!this.generalService.isNullOrEmpty(this.forwardingDetails['ruleId'])" *ngIf="forwardingDetails['isSubdomain'] === true" [validator]="validator['subdomain']"
      [(ngModel)]="forwardingDetails['subdomain']" title="Subdomain" placeholder="Enter your subdomain"
      suffix="{{domain}}">

    </app-input-prefix-field>

    <app-input-field [validator]="validator['destination_url']" [(ngModel)]="forwardingDetails['destination_url']"
      title="Destination URL" placeholder="Enter your destination url">
    </app-input-field>

    <app-selection-field [validator]="validator['status_code']" [model]="forwardingDetails" field="status_code"
      [filter]="false" [options]="statusCodes" title="Status Code" placeholder="Select a status code">
    </app-selection-field>

    <div style="display: flex; gap: 12px; justify-content: flex-end;">
      <div class="button body-sm-medium" style="background-color: #E4E0EB; border: none; color: black;"
        (click)="modalCtrl.dismiss()">
        Cancel
      </div>
      <div (click)=" handleConfirm()" class="button body-sm-medium">Confirm
      </div>

    </div>

  </div>




</ion-content>